export default __webpack_public_path__ + "static/media/Trailer.d5833cf2.m4v";